import React, { Component } from "react";
import { withAuth } from "../../../shared/containers/containerAuth";
import { withSignalR } from "../../../shared/containers/containerSignalR";
import { withPopupNotification } from "../../../shared/containers/containerPopupNotification";
import { HubConnectionState } from "@microsoft/signalr";
import { states } from "../../../reducers/queriesStates";
import { NotificationContainer, NotificationManager } from "react-notifications";
import "react-notifications/lib/notifications.css";
import popupNotificationService from "../../../shared/services/popupNotificationService";
import "./popupNotification.css";

import { withNotifications } from "../../../shared/containers/containerNotifications";
import { notificationStates } from "../../../reducers/notificationStates";

const CONNECTION_TIMER = 60000;
let handleConnectLastState;
let handleStartConnection;
let handleAddUserToGroup;

class PopupNotification extends Component {
  constructor(props) {
    super(props);

    this.state = { isAllowed: false, isOnRecieve: false };
  }

  componentDidMount() {
    const { data } = this.props;
    const isAllowed = data.permissions.includes(26001);
    this.setState({ isAllowed });

    if (isAllowed) {
      const { dataConnectionStateSR, connectionSR, onStartConnection, dataStartConnectionStateSR } = this.props;

      console.log(dataConnectionStateSR, connectionSR, dataStartConnectionStateSR);

      //start connection if app has connected yet
      if (
        dataStartConnectionStateSR === states.NOT_REQUESTED &&
        dataConnectionStateSR === states.READY &&
        !!connectionSR &&
        connectionSR.connectionState === HubConnectionState.Disconnected
      ) {
        onStartConnection(connectionSR);
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { isAllowed, isOnRecieve } = this.state;

    if (isAllowed) {
      const {
        dataConnectionStateSR,
        connectionSR,
        dataStartConnectionStateSR,
        dataUserGroupStateSR,
        onStartConnection,
        onAddUserToGroup,
        onConnectLastState,
        onRecievePopupNotification,
        dataRecievePopupNotification,
      } = this.props;
      
      //connect if never connection
      if (dataConnectionStateSR === states.NOT_REQUESTED) {
        onConnectLastState();
      }

      // repeat connection if previous was a failure or closed
      if (dataConnectionStateSR === states.FAILURE && prevProps.dataConnectionStateSR !== states.FAILURE) {
        handleConnectLastState = setTimeout(() => {
          onConnectLastState();
        }, CONNECTION_TIMER);
      }

      // connect if previous connection was stopped
      if (
        dataStartConnectionStateSR === states.NOT_REQUESTED &&
        prevProps.dataStartConnectionStateSR !== states.NOT_REQUESTED &&
        dataConnectionStateSR === states.READY &&
        connectionSR.connectionState === HubConnectionState.Disconnected
      ) {
        onStartConnection(connectionSR);
      }

      // reconnect if connection is ready, but previous attempt to start was a failure
      if (
        dataStartConnectionStateSR === states.FAILURE &&
        prevProps.dataStartConnectionStateSR !== states.FAILURE &&
        dataConnectionStateSR === states.READY
      ) {
        handleStartConnection = setTimeout(() => {
          onStartConnection(connectionSR);
        }, CONNECTION_TIMER);
      }

      // connection is started, then add usergroup
      if (dataStartConnectionStateSR === states.READY && prevProps.dataStartConnectionStateSR !== states.READY) {
        onAddUserToGroup(connectionSR);
      }

      // repeat adding user to group if previous attempt was a failure
      if (dataUserGroupStateSR === states.FAILURE && prevProps.dataUserGroupStateSR !== states.FAILURE) {
        handleAddUserToGroup = setTimeout(() => {
          onAddUserToGroup(connectionSR);
        }, CONNECTION_TIMER);
      }

      // trigger to start recieve lastState
      if (
        dataConnectionStateSR === states.READY &&
        dataStartConnectionStateSR === states.READY &&
        dataUserGroupStateSR === states.READY &&
        dataRecievePopupNotification === states.NOT_REQUESTED &&
        !isOnRecieve
      ) {
        this.setState({ isOnRecieve: true });
        onRecievePopupNotification(connectionSR, this.createNotification.bind(this));
      }
    }
  }

  createNotification = (data) => {
    const notification = popupNotificationService.getNotification(data);

    this.showNotification(notification);
  };

  showNotification(notification) {
    const { onStateNotification } = this.props;

    const collBack = () => {
      onStateNotification(notification.id, notificationStates.READ);
    };

    switch (notification.level) {
      case 1:
        NotificationManager.success(notification.text, notification.title, 10000);
        break;
      case 2:
        NotificationManager.warning(notification.text, notification.title, 10000);
        break;
      case 3:
        NotificationManager.error(notification.text, notification.title, 10000, collBack);
        break;
      default:
        NotificationManager.info(notification.text, notification.title, 10000);
        break;
    }
  }

  showAll() {
    const { notifications, onStateNotification } = this.props;

    notifications
/*       .filter((x) => {
        return x.state === notificationStates.NOT_SHOW;
      }) */
      .forEach((x) => {
        this.showNotification(x);
        onStateNotification(x.id, notificationStates.SHOW);
      });
  }

  render() {
    const { isAllowed } = this.state;

    if (!isAllowed) {
      return null;
    }

    return (
      <div>
        <NotificationContainer />
        {this.showAll()}
      </div>
    );
  }
}

export default withNotifications(withPopupNotification(withSignalR(withAuth(React.memo(PopupNotification)))));
